<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2 class="mt-5">{{$t('message.Home_page')}}</h2>
        <b-row style="padding: 0 5% 0 5%">
          <b-col cols="4">
            <Stat icon="bx bx-file" :title="$t('message.Vacancy_count')" :value="freeVacancies.total" />
          </b-col>
          <b-col cols="4">
            <Stat icon="bx bx-spreadsheet" :title="$t('message.Test_question_number')" :value="testQuestions" />
          </b-col>
          <b-col cols="4">
            <Stat icon="bx bx-spreadsheet" :title="$tc('message.fullVacancies', acceptedApplications)" :value="''" />
          </b-col>
        </b-row>
        <div>
          <b-card style="width: 90%; margin: 0 auto;">
          <apexchart width="800" type="line" :options="options" :series="series" class="d-flex"></apexchart>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import Stat from "@/components/widgets/stat";
import HorizontalTopbarInside from "../../../../../components/horizontal-topbar-inside";
import {getModeratorReports} from "../../../../../api/reports";


export default {
  name: "ModeratorProfile",
  components: {
    HorizontalTopbarInside, SideBar,Stat,
  },
  data() {
    return {
      isMenuCondensed: false,
      freeVacancies: 0,
      testQuestions: 0,
      acceptedApplications:0,
      accepted: [],
      rejected: [],
      statData: [
        {
          icon: "bx bx-file",
          title: this.$t('message.Vacancy'),
          value: "14",
        },
      ],
      dataStat: [
        {
          icon: "bx bx-archive-in",
          title: this.$t('message.Application_number'),
          value: "20",
        },
      ],
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        }
      },
      series: [{
        name: 'series-1',
        data: []
      }]
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");

  },
  methods: {
    fetchModeratorReports() {
      getModeratorReports().then(res => {
        this.freeVacancies = res.data.vacancies;
        this.testQuestions = res.data.testQuestions;
        this.accepted = res.data.applicationsAccepted;
        this.rejected = res.data.applicationsRejected;
        this.acceptedApplications = res.data.acceptedApplications;
        let acceptSeries = [];
        let rejectSeries = [];
        let labels = [];
        this.accepted.forEach(item => {
          acceptSeries.push(item.data);
          labels.push(item.month);
        })
        this.rejected.forEach(item => {
          rejectSeries.push(item.data);
        })
        this.series = [{name: this.$t('message.Accept'),data: acceptSeries},{name:this.$t('message.Rejected'),data:rejectSeries}]
        this.options = {...this.options, ...{xaxis:{categories:labels}}}
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    this.fetchModeratorReports()
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
</style>
<style>
.apexcharts-toolbar{
  display: none;
}
</style>

